<template>
  <a-modal
    v-model:visible="visible"
    :title="title"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
    okText="确定"
    cancelText="取消"
    :maskClosable="false"
  >
    <a-form
      :model="formData"
      ref="formRef"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item
        v-for="(item, index) in formItems"
        :key="index"
        :label="item.name"
        :name="item.name"
      >
        <a-input
          v-if="item.type == 'input'"
          v-model:value="formData[item.name]"
        />
        <a-textarea
          v-if="item.type == 'textarea'"
          v-model:value="formData[item.name]"
          :placeholder="`请输入${item.name}`"
          :rows="4"
        />
        <a-radio-group
          v-if="item.type == 'radio'"
          :options="item.options"
          v-model:value="formData[item.name]"
        />
        <a-checkbox-group
          v-if="item.type == 'checkbox'"
          v-model:value="formData[item.name]"
          :options="item.options"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { ref, defineComponent, reactive, toRefs } from 'vue'
import { v1_portal_uer_feedback_post } from '/src/server/modules/feedback.js'
import { message } from 'ant-design-vue'

export default defineComponent({
  emits: ['submit', 'cancel'],
  setup(props, { emit }) {
    const visible = ref(false)
    const loading = ref(false)
    const formData = ref({})
    const formRef = ref(null)
    const state = reactive({
      title: '',
      formItems: [],
      layout: 'vertical',
      project: null,
      apiData: null,
      baseData: null
    })
    const open = ({ formItems, project, apiData, baseData }) => {
      state.title = project.name + apiData.name
      state.baseData = baseData
      state.apiData = apiData
      state.project = project
      state.formItems = formItems
      visible.value = true
    }

    const handleOk = async () => {
      loading.value = true
      try {
        const form = formRef.value
        await form.validate()
        const len = Object.keys(formData.value).length
        // if (!len) {
        //   message.error('请留下您的评价')
        //   return
        // }
        if (len) {
          const params = {
            ...state.baseData,
            projectId: state.project.id,
            url: location.href,
            configId: state.apiData.id,
            extraParams: JSON.stringify(formData.value)
          }
          await v1_portal_uer_feedback_post(params)
        }

        handleCancel()
        message.success('感谢您的评价')
      } catch (err) {
        handleCancel()
      } finally {
        loading.value = false
      }
    }

    const handleCancel = () => {
      emit('cancel')
      state.title = ''
      formData.value = {}
      state.title = ''
      state.baseData = null
      state.apiData = null
      state.project = null
      state.formItems = null
      visible.value = false
    }

    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      open,
      visible,
      loading,
      formData,
      formRef,
      handleOk,
      handleCancel,
      ...toRefs(state)
    }
  }
})
</script>
